import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {
	return ( {

		blogPageContainer: {
			display       : "flex",
			flexDirection : "column",
			margin        : "5rem 0 10rem",
			gap           : "5rem",
			padding       : props?.deviceViewTab ? "0 20px" : "0 200px"
		}
	} );
} );
